import { Subject } from 'rxjs';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UploadFileService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.obs$ = new Subject();
    }
    uploadFile(url, opNumber, file, ezsharedParameter) {
        let req;
        const fileData = new FormData();
        if (file === null) {
            req = `?operationNumber=${opNumber}&documentNumber=${ezsharedParameter}`;
            return this.httpClient.post(url + req, null);
        }
        else {
            fileData.append('file', file);
            req = `?documentName=${file.name}&operationNumber=${opNumber}&auditYear=2019
      &searchParameters=${ezsharedParameter}`;
            return this.httpClient.post(url + req, fileData);
        }
    }
    documentSearch(operationNumber) {
        return this.httpClient.get(environment.api.baseUpload + 'documents' + '?OperationNumber=' + operationNumber);
    }
}
UploadFileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UploadFileService_Factory() { return new UploadFileService(i0.ɵɵinject(i1.HttpClient)); }, token: UploadFileService, providedIn: "root" });
